/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class CreateBuffer {
    static readonly type = '[Buffer] Create buffer';

    constructor(public bufferDistance: number, public selectWithin: boolean) {}
}

export class ClearBuffer {
    static readonly type = '[Buffer] Clear buffer';
}
